import * as tslib_1 from "tslib";
import { State, Action, Store, Selector } from '@ngxs/store';
var category = 'Settings';
var SetUsageAlerts = /** @class */ (function () {
    function SetUsageAlerts(alerts) {
        this.alerts = alerts;
    }
    SetUsageAlerts.type = "[" + category + "] UsageAlerts";
    return SetUsageAlerts;
}());
export { SetUsageAlerts };
var SetDNASchedules = /** @class */ (function () {
    function SetDNASchedules(schedules) {
        this.schedules = schedules;
    }
    SetDNASchedules.type = "[" + category + "] SetDNASchedules";
    return SetDNASchedules;
}());
export { SetDNASchedules };
var SettingsState = /** @class */ (function () {
    function SettingsState(store) {
        this.store = store;
    }
    SettingsState_1 = SettingsState;
    // available spans state
    SettingsState.usageAlerts = function (state) {
        return state.usageAlerts;
    };
    SettingsState.prototype.setUsageAlerts = function (ctx, action) {
        ctx.patchState({
            usageAlerts: action.alerts,
        });
    };
    // selected spans state
    SettingsState.schedules = function (state) {
        return state.schedules;
    };
    SettingsState.prototype.setDNASchedules = function (ctx, action) {
        ctx.patchState({
            schedules: action.schedules,
        });
    };
    SettingsState.prototype.getUsageAlerts = function () {
        return this.store.selectSnapshot(SettingsState_1.usageAlerts);
    };
    SettingsState.prototype.getDNASchedules = function () {
        return this.store.selectSnapshot(SettingsState_1.schedules);
    };
    var SettingsState_1;
    tslib_1.__decorate([
        Action(SetUsageAlerts),
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [Object, SetUsageAlerts]),
        tslib_1.__metadata("design:returntype", void 0)
    ], SettingsState.prototype, "setUsageAlerts", null);
    tslib_1.__decorate([
        Action(SetDNASchedules),
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [Object, SetDNASchedules]),
        tslib_1.__metadata("design:returntype", void 0)
    ], SettingsState.prototype, "setDNASchedules", null);
    tslib_1.__decorate([
        Selector([SettingsState_1]),
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [Object]),
        tslib_1.__metadata("design:returntype", void 0)
    ], SettingsState, "usageAlerts", null);
    tslib_1.__decorate([
        Selector([SettingsState_1]),
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [Object]),
        tslib_1.__metadata("design:returntype", void 0)
    ], SettingsState, "schedules", null);
    SettingsState = SettingsState_1 = tslib_1.__decorate([
        State({
            name: 'settings',
            defaults: {
                usageAlerts: [],
                schedules: [],
            },
        }),
        tslib_1.__metadata("design:paramtypes", [Store])
    ], SettingsState);
    return SettingsState;
}());
export { SettingsState };
